import { put, select, takeEvery } from 'redux-saga/effects';
import { keyBy } from 'lodash';
import ActionTypes from '../../../../Data/ActionTypes';
import { NAVIGATION_BLOCKS } from '../../../../Data/Constants';
import { ComponentTypes } from '../../../../Data/Components';
import { setSelectAndConnectBrands } from '../../slices/submission';
import SubmissionStatus from '../../../../Data/SubmissionStatus';

export function* submitSelectAndConnectWorker(action) {
  const { payload } = action;
  const { selectAndConnectPage } = payload;

  const components = yield select((store) => store.components);

  try {
    yield put({
      type: 'NAVIGATION_CONTROLS/setNavigationBlockOnPage',
      payload: {
        pageNumber: selectAndConnectPage,
        blockName: NAVIGATION_BLOCKS.SELECT_AND_CONNECT,
        isPreventingNavigation: true,
      },
    });

    const selectAndConnectComponent = Object.values(components).find(
      (component) =>
        component.component.type === ComponentTypes.SELECT_AND_CONNECT
    );

    const selectAndConnectBrands =
      selectAndConnectComponent.input.selectedOptions.map((supplierId) => {
        const foundSupplier =
          selectAndConnectComponent.component.additionalSettings.suppliers.find(
            (supplier) => supplier.supplier_id === supplierId
          );

        return {
          brandId: foundSupplier.brandId,
          brandRevisionId: foundSupplier.brandRevisionId,
          submissionStatus: SubmissionStatus.NOT_STARTED,
        };
      });

    yield put(
      setSelectAndConnectBrands({
        selectAndConnectBrands: keyBy(selectAndConnectBrands, 'brandId'),
      })
    );
  } catch (error) {
    yield put({
      type: 'NAVIGATION_CONTROLS/setNavigationBlockOnPage',
      payload: {
        pageNumber: selectAndConnectPage,
        blockName: NAVIGATION_BLOCKS.SELECT_AND_CONNECT,
        isPreventingNavigation: false,
      },
    });
  }
}

export default function* submitSelectAndConnectSaga() {
  yield takeEvery(
    ActionTypes.SUBMIT_SELECT_AND_CONNECT,
    submitSelectAndConnectWorker
  );
}
